<template>
    <div class="DocumentEditor">

        <b-modal ref="component-modal" :title="ModalTitle" size="lg" hide-footer no-close-on-esc no-close-on-backdrop>
            <b-container>
                <b-row v-if="IsExistingDocument">
                    <b-col>
                        <p>Last Modified: {{MetaData.UpdatedAt}} by {{MetaData.UpdatedBy}}</p>
                        <p v-for="feedback in Feedback" class="orange-bg">
                            <span class="bold">Feedback by {{ feedback.Reviewer }} on {{ feedback.ReviewedAt }}:</span> {{ feedback.Comments }}
                        </p>
                        <p class="bold">Signatures:</p>
                        <ul>
                            <li v-for="sig in MetaData.Signatures">
                                {{ sig.ApprovalLabel }}: <span v-if="sig.ReviewerDecision == 'Approved'">Signed {{ formatUTCDate(sig.ReviewerDecisionAt,'MM/DD/YYYY h:mm A') }} by {{ sig.Reviewer.FullName }} <font-awesome-icon :icon="['fa', 'trash-alt']" class="red pointer" @click="RemoveSignatureFromDocument(sig.Id)" /></span><span v-else>PENDING</span>
                            </li>
                        </ul>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <b-form @submit="SubmitForm" ref="DocumentEditorForm" class="form-interior">
                            <FormBlock :form-block-item="FormBlockSchema" :chart-id="ChartRecordId" :input-values="InputValues" :show-reviewer-comments="(Feedback.length > 0 || EditingSubmittedDocument) && CheckPermission('CanViewReviewerComments') && CheckPermission('AdminsOnly') == false" :edit-reviewer-comments="EditingSubmittedDocument && CheckPermission('AdminsOnly') == false" />
                            <b-row v-if="UseProblemsList">
                                <b-col>
                                    <b-row>
                                        <b-col>
                                            <ProblemsListEditor :chart-id="ChartRecordId" />
                                        </b-col>
                                    </b-row>
                                </b-col>
                            </b-row>
                            <b-row class="modal-btn-row">
                                <div class="modal-btn-row-div">
                                    <b-button size="md" variant="secondary" @click="Cancel()">
                                        CANCEL
                                    </b-button>
                                    <b-button size="md" variant="success" type="submit" v-if="DocumentRequiresApproval == true && EditingSubmittedDocument == false">
                                        <font-awesome-icon :icon="['fas', 'paper-plane']" />
                                        SUBMIT
                                    </b-button>
                                    <b-button size="md" variant="success" type="submit" v-if="EditingSubmittedDocument == true">
                                        <font-awesome-icon :icon="['fas', 'paper-plane']" />
                                        SAVE CHANGES
                                    </b-button>
                                    <b-button size="md" variant="success" type="submit" v-if="DocumentRequiresApproval == false && EditingSubmittedDocument == false">
                                        <font-awesome-icon :icon="['fa', 'folder']" />
                                        FILE
                                    </b-button>
                                    <b-button size="md" variant="warning" @click="SaveDraft()" v-if="EditingSubmittedDocument == false">
                                        <font-awesome-icon :icon="['fas', 'save']" />
                                        SAVE DRAFT
                                    </b-button>
                                    <b-button size="md" variant="warning" @click="ShowTemplateImportModal" v-if="FormData.Form!= null && FormData.Form.AllowWordImport">
                                        <font-awesome-icon :icon="['fas', 'upload']" />
                                        IMPORT TEMPLATE
                                    </b-button>
                                    <b-button v-if="IsExistingDocument && EditingSubmittedDocument == false" size="md" variant="danger" type="button" @click="OpenDeleteDraftConfirmation()">
                                        <font-awesome-icon :icon="['fa', 'trash-alt']" />
                                        DELETE DRAFT
                                    </b-button>
                                </div>
                            </b-row>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row v-if="IsExistingDocument">
                    <p>
                        Last Modified: {{
MetaData.UpdatedAt
                        }} by {{MetaData.UpdatedBy}}
                    </p>
                </b-row>
            </b-container>
            <DigitalPasswordSignature ref="signature-modal-component" modal-title="Digitally Sign Document" v-on:passwordentered="SubmitDocument" />
        </b-modal>

        <b-modal ref="template-modal" title="Import Word Template" size="md" hide-footer>
            <b-container>
                <b-form @submit="SubmitTemplateImport" ref="import-word-form">
                    <b-form-group label="Select Word File (.docx) to Import:">
                        <b-form-file class="form-control"
                                     name="FormFile"
                                     required
                                     placeholder="Click to Select File or Drag/Drop"
                                     drop-placeholder="Drop word file here..."></b-form-file>
                    </b-form-group>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelImport()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="button" @click="DownloadTemplateFile">
                                <font-awesome-icon :icon="['fas', 'download']" />
                                DOWNLOAD TEMPLATE
                            </b-button>
                            <b-button size="md" variant="warning" type="submit">
                                <font-awesome-icon :icon="['fas', 'upload']" />
                                IMPORT FILE
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <b-modal ref="delete-confirm-modal" title="CONFIRM DOCUMENT DELETION" size="md" hide-footer>
            <b-container>
                <div>
                    <p class="red"><span class="bold">WARNING!</span>  YOU ARE ABOUT TO DELETE THIS DOCUMENT. ONCE DELETED, THIS DOCUMENT CAN NOT BE RECOVERED.</p>
                    <b-form-group label="Type the sentance DELETE THIS DOCUMENT below to proceed:">
                        <input class="form-control" v-model="DeleteText" required placeholder="DELETE THIS DOCUMENT" />
                    </b-form-group>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelDeleteDraftConfirmation()">
                                CANCEL
                            </b-button>
                            <b-button v-if="DeleteText.toUpperCase() == 'DELETE THIS DOCUMENT'" size="md" variant="danger" type="button" @click="DeleteDraft()">
                                <font-awesome-icon :icon="['fas', 'trash', 'alt']" />
                                DELETE
                            </b-button>
                        </div>
                    </b-row>
                </div>
            </b-container>
        </b-modal>

    </div>

</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSave } from '@fortawesome/free-solid-svg-icons';
    library.add(faSave);
    import { faPaperPlane } from '@fortawesome/free-solid-svg-icons';
    library.add(faPaperPlane);
    import { faFolder } from '@fortawesome/free-solid-svg-icons';
    library.add(faFolder);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import { faDownload } from '@fortawesome/free-solid-svg-icons';
    library.add(faDownload);
    import { faUpload } from '@fortawesome/free-solid-svg-icons';
    library.add(faUpload);

    import FormBlock from "./FormBlock.vue";
    import DigitalPasswordSignature from "./DigitalPasswordSignature.vue";
    //import ProblemsList from "../ItemEditors/ProblemsList.vue";
    import ProblemsListEditor from "../../MentalHealth/Editors/ProblemsListEditor.vue";

    import { EventBus } from '../../../services/event-bus.js';

    export default {
        props: [
            "ChartRecordIdPreset",
            "EditingSubmittedDocument"
        ],
        created: function () {
            let vm = this;
            EventBus.$on('duplicate-check-needed', msg => {
                //Check for duplicate MH Progress Note if this is an MH PRogress Note
                if (vm.FormData.FormID == "36518176-56d5-4240-3319-08dbd4a0db07") {
                    if (vm.InputValues["DateOfService"] && vm.InputValues["ServiceProvided"]) {
                        vm.CheckForDuplicateServiceExistance();
                        
                    }
                }
            });
        },
        beforeDestroy() {
            EventBus.$off('duplicate-check-needed');
        },
        data: function () {
            return {
                FormData: {},
                InputValues: {},
                FormSubProgramMembership: {},
                ChartRecordId: "",
                DocumentId: "",
                MetaData: {},
                Signatures: [],
                DeleteText: "",
                NewDocPayload: null,
            }
        },
        methods: {
            CheckForDuplicateServiceExistance() {
                this.$MasterAPI.ExecuteRequest("GET", "Documents/CheckForMHPRogressNoteDuplicate", { DocumentID: this.DocumentId, ChartID: this.ChartRecordId, ServiceProvided: this.InputValues['ServiceProvided'], DateOfService: this.InputValues['DateOfService'] }, this.CheckForDuplicateServiceExistanceSuccess, this.CheckForDuplicateServiceExistanceError, false);
            },
            CheckForDuplicateServiceExistanceSuccess(response) {
                //do nothing
            },
            CheckForDuplicateServiceExistanceError(error) {
                this.InputValues['ServiceProvided'] = null;
            },
            SetFormSubProgramMembership: function (formSubProgramMembership) {
                this.$set(this, 'FormSubProgramMembership', formSubProgramMembership);
            },
            ShowNewDocumentModal: function (formSubProgramMembership, startDate, endDate, carryForwardLastDocument) {
                //var vm = this;
                //set data
                this.DocumentId = "";
                this.Signatures = [];
                this.$set(this, 'MetaData', {});
                this.$set(this, 'FormSubProgramMembership', formSubProgramMembership);
                //Retreive Form from Server
                this.$MasterAPI.ExecuteRequest("GET", "Core/Documents/GetFormForNewDocument", { FormID: this.FormSubProgramMembership.Id, ChartID: this.ChartRecordId, StartDate: startDate, EndDate: endDate, carryForwardLastDocument: carryForwardLastDocument }, this.ShowNewDocumentModalSuccess, () => { }, true);

            },
            ShowNewDocumentModalWithPresets: function (formSubProgramMembership, newDocPayload) {
                this.NewDocPayload = newDocPayload;
                //var vm = this;
                //set data
                this.DocumentId = "";
                this.Signatures = [];
                this.$set(this, 'MetaData', {});
                this.$set(this, 'FormSubProgramMembership', formSubProgramMembership);
                //Retreive Form from Server
                this.$MasterAPI.ExecuteRequest("GET", "Core/Documents/GetFormForNewDocument", { FormID: this.FormSubProgramMembership.Id, ChartID: this.ChartRecordId, StartDate: null, EndDate: null, carryForwardLastDocument: false }, this.ShowNewDocumentModalWithPresetsSuccess, () => { }, true);

            },
            ShowNewDocumentModalWithPresetsSuccess(response) {
                //add response to FormData
                response.data.data.Form.HtmlFormTemplate = JSON.parse(response.data.data.Form.HtmlFormTemplate);
                this.$set(this, 'FormData', response.data.data);
                //add response to InputValues
                let inputValues = {};
                response.data.data.Form.FormFields.forEach(function (item) {
                    if (item.FieldDataStructure == "Multiple" || item.FieldDataStructure == "MultipleToMultipleCheck" || item.FieldDataStructure == "MultiplePersonIds") {
                        inputValues[item.Name] = (item.DefaultValue != null ? item.DefaultValue.split(",") : []);
                    } else {
                        inputValues[item.Name] = item.DefaultValue;
                    }
                });

                //START INOUT VALUES OVERRIDE FOR PRESETS

                inputValues.ServiceProvided = this.NewDocPayload.ServiceName;
                inputValues.DateOfService = this.NewDocPayload.DateOfService;
                inputValues.StartTime = this.NewDocPayload.StartTime;
                inputValues.EndTime = this.NewDocPayload.EndTime;
                
                //END INPUT VALUES OVERRIDE FOR PRESETS

                this.$set(this, 'InputValues', inputValues);
                if (response.data.data.IncludeProblemsList) {
                    //this.GetProblemsList();
                }
                //show modal
                this.$refs['component-modal'].show();
            },
            ShowNewDocumentModalSuccess(response) {
                //add response to FormData
                response.data.data.Form.HtmlFormTemplate = JSON.parse(response.data.data.Form.HtmlFormTemplate);
                this.$set(this, 'FormData', response.data.data);
                //add response to InputValues
                let inputValues = {};
                response.data.data.Form.FormFields.forEach(function(item){
                    if (item.FieldDataStructure == "Multiple" || item.FieldDataStructure == "MultipleToMultipleCheck" || item.FieldDataStructure == "MultiplePersonIds") {
                        inputValues[item.Name] = (item.DefaultValue != null ? item.DefaultValue.split(",") : []);
                    } else {
                        inputValues[item.Name] = item.DefaultValue;
                    }
                });
                this.$set(this, 'InputValues', inputValues);
                if (response.data.data.IncludeProblemsList) {
                    //this.GetProblemsList();
                }
                //show modal
                this.$refs['component-modal'].show();
            },
            GetProblemsList() {
                this.$MasterAPI.ExecuteRequest("GET", "Clients/ProblemsList", { Id: this.ChartRecordId }, this.GetProblemsListSuccess, () => { }, true);
            },
            GetProblemsListSuccess(response) {
                this.ProblemsList = response.data.data;
            },
            ShowTemplateImportModal() {
                this.$refs['template-modal'].show();
            },
            SubmitTemplateImport(e) {
                e.preventDefault();
                //let vm = this;
                let form = this.$refs['import-word-form'];
                let formData = new FormData(form);

                formData.append("FormID", this.FormSubProgramMembership.Id);
                formData.append("ChartID", this.ChartRecordId);
                this.$MasterAPI.ExecuteRequest("POST", "Core/Documents/GetFormForNewDocumentUsingWordFile", formData, this.SubmitTemplateImportSuccess, () => { }, true);

            },
            SubmitTemplateImportSuccess(response) {
                this.$refs['component-modal'].hide();
                let inputValues = {};
                response.data.data.Form.FormFields.forEach(function (item) {
                    if (item.FieldDataStructure == "Multiple" || item.FieldDataStructure == "MultipleToMultipleCheck" || item.FieldDataStructure == "MultiplePersonIds") {
                        inputValues[item.Name] = (item.DefaultValue != null ? item.DefaultValue.split(",") : []);
                    } else {
                        inputValues[item.Name] = item.DefaultValue;
                    }
                });
                this.$set(this, 'InputValues', inputValues);
                this.$refs['template-modal'].hide();
                this.$refs['component-modal'].show();
            },
            ShowExistingDocumentModal: function (documentID) {
                //Retreive Form from Server
                this.$MasterAPI.ExecuteRequest("GET", "Core/Documents/GetDocumentForEditing", { DocumentID: documentID }, this.ShowExistingDocumentModalSuccess, () => { }, false);
            },
            ShowExistingDocumentModalSuccess(response) {
                let vm = this;
                //add response to FormData
                response.data.data.Form.HtmlFormTemplate = JSON.parse(response.data.data.Form.HtmlFormTemplate);
                vm.$set(vm, 'FormData', response.data.data);

                let metaData = {
                    UpdatedAt: vm.formatUTCDate(response.data.data.UpdatedAt, "MM/DD/YYYY h:mm A"),
                    UpdatedBy: response.data.data.UpdatedBy,
                    Signatures: response.data.data.DocumentSignatures
                };
                vm.$set(vm, 'MetaData', metaData);
                //set chart record ID
                vm.ChartRecordId = response.data.data.ChartID;
                vm.DocumentId = response.data.data.Id;
                //set signatures
                vm.Signatures = response.data.data.DocumentSignatures;
                            
                //set form subprogram membership
                vm.$set(vm, 'FormSubProgramMembership', response.data.data.FormSubProgramMembership);
                //add response to InputValues
                let inputValues = {};
                response.data.data.DocumentFields.forEach(function (item) {
                    if (item.FormField.FieldDataStructure == "Multiple" || item.FormField.FieldDataStructure == "MultipleToMultipleCheck" || item.FormField.FieldDataStructure == "MultiplePersonIds") {
                        inputValues[item.FormField.Name] = (item.FieldValue != null ? item.FieldValue.split(",") : []);
                    } else {
                        inputValues[item.FormField.Name] = item.FieldValue;
                    }
                });
                let reviewerComments = {};
                if (response.data.data.ReviewerComments != null) {
                    reviewerComments = JSON.parse(response.data.data.ReviewerComments);
                }
                inputValues = { ...inputValues, ...reviewerComments };
                
                vm.$set(vm, 'InputValues', inputValues);
                //show modal
                this.$refs['component-modal'].show();
            },
            SaveDraft: function () {
                
                //let form = document.getElementById('DocumentEditorForm');
                let form = this.$refs['DocumentEditorForm'];
                let formData = new FormData(form);

                formData.append("FormID", this.FormSubProgramMembership.Id);
                formData.append("ChartID", this.ChartRecordId);
                formData.append("DocumentID", this.DocumentId);
                formData.append("AuthorType","Employee");
                formData.append("SubmitType", "draft");
                this.$MasterAPI.ExecuteRequest("POST", "Documents/EditDocumentContents",formData, this.SaveDraftSuccess, () => { }, true);
            },
            SaveDraftSuccess(response) {
                let vm = this;
                //add response to FormData
                let metaData = {
                    UpdatedAt: vm.formatUTCDate(response.data.data.UpdatedAt, "MM/DD/YYYY h:m A"),
                    UpdatedBy: response.data.data.UpdatedBy,
                    Signatures: response.data.data.DocumentSignatures
                };
                vm.$set(vm, 'MetaData', metaData);
                vm.DocumentId = response.data.data.Id;
                EventBus.$emit('drafts-updated', vm.ChartRecordId);
                            
                            
                alert("Your draft has been saved");
            },
            OpenDeleteDraftConfirmation() {
                this.DeleteText = "";
                this.$refs['delete-confirm-modal'].show();
            },
            CancelDeleteDraftConfirmation() {
                this.$refs['delete-confirm-modal'].hide();
            },
            DeleteDraft() {
                this.$MasterAPI.ExecuteRequest("POST", "Core/Documents/DeleteDraft",{ DocumentID: this.DocumentId }, this.DeleteDraftSuccess, () => { }, true);
            },
            DeleteDraftSuccess(response) {
                //add response to FormData
                EventBus.$emit('drafts-updated', this.ChartRecordId);
                            
                //show modal
                this.$refs['delete-confirm-modal'].hide();
                this.$refs['component-modal'].hide();
            },
            SubmitForm(e)  {
                e.preventDefault();
                if (this.DocumentRequiresApproval && this.EditingSubmittedDocument == false) {
                    //display password modal
                    this.$refs['signature-modal-component'].ShowModal();
                }
                else {
                    this.SubmitDocument()
                }
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            CancelImport() {
                this.$refs['template-modal'].hide();
            },
            DownloadTemplateFile() {
                let payload = { FileID: this.FormData.Form.WordFileID };
                this.$MasterAPI.ExecuteFileRequest("/Core/Files/GetFileContent/" + this.FormData.Form.Name + ".docx", payload)
            },
            SubmitDocument(password = null) {
                //let form = document.getElementById('DocumentEditorForm');
                let form = this.$refs['DocumentEditorForm'];
                let formData = new FormData(form);
                //let formObj = {
                //    FormID: this.FormSubProgramMembership.Id,
                //    ChartID: this.ChartRecordId,
                //    DocumentID: this.DocumentId,
                //    AuthorType: "Employee",
                //    AuthorPassword: password
                //};
                formData.append("FormID", this.FormSubProgramMembership.Id);
                formData.append("ChartID", this.ChartRecordId);
                formData.append("DocumentID", this.DocumentId);
                formData.append("AuthorType","Employee");
                formData.append("AuthorPassword", password);

                //formData.forEach(function(value, key){
                //    formObj[key] = value;
                //});

                let actionMethod = "submit"; 
                if (this.EditingSubmittedDocument == true) {
                    actionMethod = "change";
                }
                formData.append("SubmitType", actionMethod);
                this.$MasterAPI.ExecuteRequest("POST", "Documents/EditDocumentContents",formData, this.SubmitDocumentSuccess, () => { }, true);
            },
            SubmitDocumentSuccess(response) {
                let vm = this;
                let metaData = {
                    UpdatedAt: vm.formatUTCDate(response.data.data.UpdatedAt, "MM/DD/YYYY h:m A"),
                    UpdatedBy: response.data.data.UpdatedBy,
                    Signatures: response.data.data.DocumentSignatures
                };
                vm.$set(vm, 'MetaData', metaData);
                vm.DocumentId = response.data.data.Id;
                EventBus.$emit('drafts-updated', vm.ChartRecordId);
                            
                if (this.EditingSubmittedDocument == true) {
                    alert("Your changes have been saved.");
                }
                this.$refs['component-modal'].hide();
            },
            RemoveSignatureFromDocument: function (signatureID) {
                this.$MasterAPI.ExecuteRequest("POST", "Documents/RemoveSignatureFromDocument",{Id: signatureID}, this.RemoveSignatureFromDocumentSuccess, () => { }, true);
            },
            RemoveSignatureFromDocumentSuccess(response) {
                let vm = this;
                //add response to FormData
                let metaData = {
                    UpdatedAt: vm.MetaData.UpdatedAt,
                    UpdatedBy: vm.MetaData.UpdatedBy,
                    Signatures: vm.MetaData.Signatures.filter(ds => ds.Id != signatureID)
                };
                vm.$set(vm, 'MetaData', metaData);
                EventBus.$emit('drafts-updated', vm.ChartRecordId);
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            formatUTCDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment.utc(value, 'YYYY-MM-DD HH:mm:ss').local().format(fmt)
            },
            formatLocalDateTime(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment.utc(value, 'YYYY-MM-DD HH:mm:ss').format(fmt)
            },
            CheckPermission(permissionName) {
                return this.$store.getters["User.PrivateProfile.CheckPermission"](permissionName);
            },
        },
        components: {
            FormBlock,
            DigitalPasswordSignature,
            ProblemsListEditor
        },
        computed: {
            FormBlockSchema: function () {
                if (Object.entries(this.FormData).length === 0 && this.FormData.constructor === Object) {
                    return {};
                }
                else {
                    return this.FormData.Form.HtmlFormTemplate;
                }
            },
            ModalTitle: function () {
                if (this.FormSubProgramMembership.hasOwnProperty("Form")) {
                    return this.FormSubProgramMembership.Form.Label;
                }
            },
            IsExistingDocument: function () {
                if (!this.DocumentId) {
                    return false;
                } else {
                    return true;
                }
            },
            DocumentRequiresApproval: function () {
                if (this.FormSubProgramMembership.hasOwnProperty('DocumentRequiresApproval')) {
                    return this.FormSubProgramMembership.DocumentRequiresApproval;
                } else {
                    return null;
                }
            },
            DocumentRequiresApprovalFromNonAuthor: function () {
                if (this.FormSubProgramMembership.hasOwnProperty('DocumentRequiresApprovalFromNonAuthor')) {
                    return this.FormSubProgramMembership.DocumentRequiresApprovalFromNonAuthor;
                } else {
                    return null;
                }
            },
            Feedback: function () {
                let feedbackList = [];
                for (var i = 0; i < this.Signatures.length; i++) {
                    if (this.Signatures[i].ReviewerDecision == "Rejected") {
                        feedbackList.push({
                            Comments: this.Signatures[i].Comments,
                            Reviewer: this.Signatures[i].Reviewer.FullName,
                            ReviewedAt: this.formatUTCDate(this.Signatures[i].ReviewerDecisionAt,  "MM/DD/YYYY h:mm A")
                        });
                    }
                }
                return feedbackList;
            },
            ConditionalSize: function () {
                if (this.ProblemsList) {
                    return "xl";
                } else {
                    return "lg"
                }
            },
            UseProblemsList: function () {
                if ((this.FormData && this.FormData.IncludeProblemsList) || (this.FormData && this.FormData.FormSubProgramMembership && this.FormData.FormSubProgramMembership.IncludeProblemsList)) {
                    return true;
                } else {
                    return false;
                }
            },
            EmployeeID: function () {
                return this.$store.getters["User.PrivateProfile"]().EmployeeID;
            },
            CurrentAuthorEmployeeID: function () {
                if (this.IsExistingDocument) {
                    return this.FormData.EmployeeAuthors.filter(x => x.EndDate == null)[0].EmployeeID;
                } else {
                    return this.EmployeeID;
                }
            }
        },
        mounted: function () {
            if (this.ChartRecordIdPreset != null) {
                    this.ChartRecordId = this.ChartRecordIdPreset;
            }
        }
    }
</script>

<style scoped>
    .orange-bg {
        background-color: orange;
    }
</style>